import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HeaderService {
  private headerSource = new BehaviorSubject<string | null>(null);
  header$ = this.headerSource.asObservable();

  setTitle(header: string) {
    this.headerSource.next(header);
  }

  clearTitle() {
    this.headerSource.next(null);
  }
}
